import React from 'react';
import { Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../../components/page-header/Header';

// Placeholder until the Masjid App exists, so the sidebar link and the
// dashboard card no longer lead to a "page not found".
const MasjidApp = () => {
    const { t } = useTranslation();

    const breadcrumbItems = [
        { label: t("universal_dashboard_text"), to: '/user-dashboard' },
        { label: t("masjidAppHeading") },
    ];

    return (
        <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
            <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-5">
                <Header title={t("masjidAppHeading")} breadcrumbItems={breadcrumbItems} />

                <div className="bg-white rounded-xl shadow-md p-8 sm:p-12 flex flex-col items-center text-center">
                    <div className="bg-blue-50 p-4 rounded-full mb-4">
                        <Smartphone className="w-10 h-10 text-blue-600" />
                    </div>
                    <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                        {t("masjid_app_coming_soon_title", "Coming soon")}
                    </h2>
                    <p className="text-gray-600 max-w-md">
                        {t(
                            "masjid_app_coming_soon_text",
                            "A mobile app for your masjid is on its way. Your community will be able to see prayer times, announcements and events on their phones."
                        )}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default MasjidApp;
